import Select from "react-select";
import React, { useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { IComboboxOption } from "../../entities/helper/IComboboxOption";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import IPlan from "../../entities/IPlan";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import UserPicker from "../../controls/UserPicker";
import IUserPickerValue from "../../entities/helper/IUserPickerValue";
import {
  API_ADMIN_PRODUCTO,
  API_ADMIN_PROVEEDOR,
  API_PROVEEDOR_GET_PLANIFICACIONES,
  API_ROLES_USERS,
  ROW_COUNT_MAX,
  URL_PROVIDER,
  URL_SUPPORT,
} from "../../helpers/variableHelper";
import { getAPI, postAPI } from "../../helpers/httpHelper";
import { E_EstadoFormPrograma, E_EstadoPlanificacion } from "../../enums/E_EstadoProveedor";
import { Form } from "react-bootstrap";
import { shortDate } from "../../helpers/dateHelper";
import { IProducto } from "../../entities/IProducto";
import { IProveedor } from "../../entities/IProveedor";
import IPlanificacion from "../../entities/IPlanificacion";
import Loading from "../../cross/Loading";
import { plan as plan2 } from "../../test/variableTest";
import { cParamsActive } from "../../helpers/paramsHelper";
const MySwal = withReactContent(Swal);

interface IAgregarPlanificacionProps {
  plan?: IPlan;
  planif?: IPlanificacion;
  loading?: boolean;
  cbPs?: Array<IProducto>;
  cbPr?: Array<IProveedor>;
  id_planif?: number;
  l_roles?: any;
  is_test?: boolean;
}
export default function AgregarPlanificacion({
  is_test,
  plan,
  planif,
  loading = false,
  cbPs,
  cbPr,
  id_planif = 0,
  l_roles,
}: IAgregarPlanificacionProps) {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(loading || false);
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);

  const [isSendingData, setIsSendingData] = useState(false);

  const [estado, setEstadoPrograma] = useState<E_EstadoFormPrograma>(E_EstadoFormPrograma.Agregar);
  const [valEvaluador, setValEvaluador] = useState<IUserPickerValue | null>();
  const [valEvaluadoresParticipantes, setValEvaluadoresParticipantes] = useState<IUserPickerValue | null>();
  const [fechaDeteccion, setFechaDeteccion] = useState<string>();
  const [comboPS, setComboPS] = useState<Array<IProducto>>(cbPs || []);
  const [refComboPS, setValComboPS] = useState<IComboboxOption | null>(null);
  const [refComboPR, setValComboPR] = useState<IComboboxOption | null>(null);
  const [comboPR, setComboPR] = useState<Array<IProveedor>>(cbPr || []);
  const [proveedorSeleccionado, setProveedorSeleccionado] = useState<IProveedor>();
  const [planificacion, setPlan] = useState<IPlanificacion>();
  const [valPlanAccion, setValPlanAccion] = useState(true);

  const [isAdmin, setIsAdmin] = useState(false);
  const formValidation = (value: any, is_Test: boolean = false) => {
    if (is_Test) {
      plan = plan2;
    }

    let arrErrors: Array<string> = [];
    let arrErrorsText: Array<string> = [];
    if (value.ID_PRODUCTO === 0) {
      arrErrors.push("ID_PRODUCTO");
      arrErrorsText.push("Debe seleccionar un producto");
    } else if (value.ID_PROVEEDOR === 0) {
      arrErrors.push("ID_PROVEEDOR");
      arrErrorsText.push("Debe seleccionar un tipo de proveedor");
    } else if (value.EVALUADOR_LIDER === "") {
      arrErrors.push("EVALUADOR_LIDER");
      arrErrorsText.push("Debe agregar un evaluador líder");
    } else if (value.FECHA_EVALUACION === "") {
      arrErrors.push("FECHA_EVALUACION");
      arrErrorsText.push("Debe agregar una fecha de evaluación");
    } else if (
      value.FECHA_EVALUACION === "" ||
      new Date(new Date(value.FECHA_EVALUACION).toISOString().slice(0, -1)).getFullYear() !== parseInt(plan?.ANIO || "0")
    ) {
      arrErrors.push("FECHA_EVALUACION");
      arrErrorsText.push("El año debe ser el mismo que el del plan");
    }

    if (arrErrorsText.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <h3>Debe considerar lo siguiente:</h3>
            {arrErrorsText.map((e) => (
              <p key={e}>{e}</p>
            ))}
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  let search = new URLSearchParams(window.location.search);
  const idProveedor = parseInt(search.get("id") || "0");
  const id_planificacion = parseInt(search.get("id_planificacion") || id_planif.toString());
  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    let roles: any = l_roles ?? [];
    if (l_roles === undefined) {
      try {
        roles = (
          await getAPI(
            `${URL_SUPPORT}${API_ROLES_USERS}/getall`,
            { Authorization: `Bearer ${token}` },
            {
              USUARIO_DISPLAY: currUser.email,
              ACTIVO: true,
              PAGINA: 1,
              PAGINADO: 10000,
              ORIENTACION: "DESC",
              ORDENADOPOR: "ID",
            }
          )
        ).result;
      } catch (e) {
        setIsLoading(false);
      }
    }
    let tiene_rol = roles.data.some((d: any) => d.ACTIVO === true && d.ID_ROLES.some((id: number) => id === 49));
    setIsAdmin(tiene_rol);
    if (id_planificacion > 0 && planif !== undefined) {
      setValComboPR({ label: returnString(planif.PROVEEDOR), value: returnString(planif.ID_PROVEEDOR?.toString()) });
      setValComboPS({ label: returnString(planif.PRODUCTO), value: returnString(planif.ID_PRODUCTO?.toString()) });
      setProveedorSeleccionado({
        PROVEEDOR_EXTERNO: planif.PROVEEDOR_RESPONSABLE,
        PROVEEDOR_EXTERNO_DISPLAY: planif.PROVEEDOR_RESPONSABLE_DISPLAY,
        USUARIOS: planif.PROVEEDOR_RESPONSABLE,
        USUARIOS_DISPLAY: planif.PROVEEDOR_RESPONSABLE_DISPLAY,
        TITULO: "",
        PAGINA: 1,
        PAGINADO: 1,
        PROVEEDOR: "",
        ORIENTACION: "",
        ORDENADOPOR: "",
      });
      setValPlanAccion(returnBoolean(planif));

      setFechaDeteccion(new Date(planif.FECHA_EVALUACION).toISOString().split("T")[0] ?? "");
      setValEvaluador({ mail: planif.EVALUADOR_LIDER, name: planif.EVALUADOR_LIDER_DISPLAY });
      setValEvaluadoresParticipantes({ mail: planif.EVALUADORES, name: planif.EVALUADORES_DISPLAY });
    }
    if (id_planificacion > 0 && planif?.ID_ESTADO === 1) {
      setEstadoPrograma(E_EstadoFormPrograma.Agregar);
    } else if (id_planificacion > 0 && planif?.ID_ESTADO === 2) {
      setEstadoPrograma(E_EstadoFormPrograma.Lectura);
    } else if (id_planificacion > 0 && planif?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas) {
      setEstadoPrograma(E_EstadoFormPrograma.Lectura);
    } else if (id_planificacion > 0 && planif?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados) {
      setEstadoPrograma(E_EstadoFormPrograma.Lectura);
    } else if (id_planificacion > 0 && planif?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada) {
      setEstadoPrograma(E_EstadoFormPrograma.Lectura);
    } else if (id_planificacion > 0 && planif?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor) {
      setEstadoPrograma(E_EstadoFormPrograma.Lectura);
    } else if (id_planificacion > 0 && planif?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas) {
      setEstadoPrograma(E_EstadoFormPrograma.Lectura);
    } else if (id_planificacion > 0 && planif?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada) {
      setEstadoPrograma(E_EstadoFormPrograma.Lectura);
    }

    if (plan?.RESPONSABLE !== currUser.email) {
      setEstadoPrograma(E_EstadoFormPrograma.Lectura);
    }

    setPlan(planif);
    let paramsActive = {
      PAGINA: 1,
      PAGINADO: 10000,
      ORDENADOPOR: "TITULO",
      ORIENTACION: "ASC",
      ACTIVO: true,
      TIPO_PROCESO: plan?.TIPO_PROCESO,
    };

    const comboPS = (await getAPI(`${URL_SUPPORT}${API_ADMIN_PRODUCTO}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboPS(comboPS);

    setIsLoading(false);
  }, []);

  const returnBoolean = (b?: any) => {
    return b.ID_TIPO_PROVEEDOR === 1 ? true : false;
  };

  const returnString = (b?: any) => {
    return b || "";
  };

  const setProveedor = async (proveedor: string) => {
    getAPI(`${URL_SUPPORT}${API_ADMIN_PROVEEDOR}/getall`, { Authorization: `Bearer ${token}` }, { PROVEEDOR: proveedor, ...cParamsActive }).then(
      (result) => {
        setProveedorSeleccionado(result.result.data[0]);
      }
    );
  };

  const handleGuardar = async (id_estado: number) => {
    let params = {
      ID: id_planificacion,
      ID_PLAN: idProveedor,
      ID_TIPO_PROCESO: valPlanAccion ? 1 : 2,
      ID_PRODUCTO: refComboPS?.value ?? "",
      ID_PROVEEDOR: refComboPR?.value ?? "",
      FECHA_EVALUACION: fechaDeteccion ?? "",
      EVALUADOR_LIDER: valEvaluador?.mail ?? "",
      PROVEEDOR_RESPONSABLE: valPlanAccion ? proveedorSeleccionado?.USUARIOS : proveedorSeleccionado?.PROVEEDOR_EXTERNO ?? "",
      PROVEEDOR_RESPONSABLE_DISPLAY: proveedorSeleccionado?.USUARIOS
        ? proveedorSeleccionado?.USUARIOS_DISPLAY
        : proveedorSeleccionado?.PROVEEDOR_EXTERNO_DISPLAY ?? "",
      EVALUADOR_LIDER_DISPLAY: valEvaluador?.name ?? "",
      EVALUADORES: valEvaluadoresParticipantes?.mail ?? "",
      EVALUADORES_DISPLAY: valEvaluadoresParticipantes?.name ?? "",
      ID_ESTADO: id_estado,
    };
    if (is_test || formValidation(params)) {
      setIsLoading(true);
      setIsSendingData(true);
      try {
        let r = (await postAPI(`${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/postplanificacion`, params, { Authorization: `Bearer ${token}` }))
          .result;
        console.log(r);
        setIsLoading(false);
        setIsSendingData(false);
        window.location.href = `proveedores/home`;
      } catch (e: any) {
        setIsSendingData(false);
        MySwal.fire({
          html: (
            <div>
              <h3>Error al crear programa</h3>
              <p>{e.response.data.msg}</p>
            </div>
          ),
          text: "",
          icon: "error",
          showCloseButton: true,
        });

        setIsLoading(false);
      }
    }
  };

  const returnValue = () => {
    if (!valPlanAccion) {
      return `${proveedorSeleccionado?.PROVEEDOR_EXTERNO_DISPLAY ?? ""}`;
    } else {
      return `${proveedorSeleccionado?.USUARIOS_DISPLAY ?? ""}`;
    }
  };

  const error = (err: any) => {
    return arrErrorEmpty.includes(err) && "error";
  };

  return (
    <div className="row">
      {isLoading ? (
        <Loading />
      ) : (
        <div className="col-12">
          <button
            hidden={true}
            data-testid="btnformvalidation"
            onClick={() => {
              formValidation(planif, true);
            }}></button>
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-4">
              <h1 className="titPrincipal colorTit">Proveedor</h1>

              <div className="card bg-light border p-3 pt-2 mt-2">
                <div className="row ajusteInput">
                  <div className="col-12">
                    <h6>
                      <span className="textSeccion">Planificación</span>
                    </h6>
                  </div>
                  <div className="col-12">
                    <h6>
                      <span className="textSeccion">{planif?.CORRELATIVO}</span>
                    </h6>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span className="text-danger">(*)</span> Producto o servicio
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {estado === E_EstadoFormPrograma.Agregar ? (
                      <Select
                        options={
                          comboPS.map((vcc) => ({
                            value: vcc.ID,
                            label: vcc.TITULO,
                          })) as any
                        }
                        placeholder="Seleccione"
                        value={refComboPS || ""}
                        isClearable={true}
                        className={`${error("ID_PRODUCTO")} borderColorGris`}
                        onChange={async (e: any) => {
                          setValComboPS(e);
                          setValComboPR(null);
                          let paramsActive = {
                            PAGINA: 1,
                            PAGINADO: ROW_COUNT_MAX,
                            ORDENADOPOR: "TITULO",
                            ORIENTACION: "ASC",
                            ACTIVO: true,
                            PRODUCTO: e.label,
                            TIPO_PROVEEDOR: valPlanAccion ? "INTERNO" : "EXTERNO",
                          };
                          const comboPR = (
                            await getAPI(`${URL_SUPPORT}${API_ADMIN_PROVEEDOR}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                          ).result.data;

                          setComboPR(comboPR);
                        }}
                      />
                    ) : (
                      <label>{planificacion?.PRODUCTO}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span className="text-danger">(*)</span> Tipo proveedor
                    </label>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {estado === E_EstadoFormPrograma.Agregar ? (
                      <>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="rdBtnPlanAccion"
                            defaultChecked={valPlanAccion}
                            onChange={async () => {
                              setValComboPR(null);
                              let paramsActive = {
                                PAGINA: 1,
                                PAGINADO: ROW_COUNT_MAX,
                                ORDENADOPOR: "TITULO",
                                ORIENTACION: "ASC",
                                ACTIVO: true,
                                PRODUCTO: refComboPS?.label,
                                TIPO_PROVEEDOR: !valPlanAccion ? "INTERNO" : "EXTERNO",
                              };
                              const comboPR = (
                                await getAPI(`${URL_SUPPORT}${API_ADMIN_PROVEEDOR}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                              ).result.data;

                              setComboPR(comboPR);
                              const v = valPlanAccion;
                              setValPlanAccion(v);
                            }}
                          />
                          <label className="form-check-label">Interno</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="rdBtnPlanAccion"
                            defaultChecked={!valPlanAccion}
                            onChange={async () => {
                              setValComboPR(null);
                              let paramsActive = {
                                PAGINA: 1,
                                PAGINADO: ROW_COUNT_MAX,
                                ORDENADOPOR: "TITULO",
                                ORIENTACION: "ASC",
                                ACTIVO: true,
                                PRODUCTO: refComboPS?.label,
                                TIPO_PROVEEDOR: !valPlanAccion ? "INTERNO" : "EXTERNO",
                              };
                              const comboPR = (
                                await getAPI(`${URL_SUPPORT}${API_ADMIN_PROVEEDOR}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                              ).result.data;

                              setComboPR(comboPR);
                              setValPlanAccion(!valPlanAccion);
                            }}
                          />
                          <label className="form-check-label">Externo</label>
                        </div>
                      </>
                    ) : (
                      <label>{planificacion?.TIPO_PROVEEDOR}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span className="text-danger">(*)</span> Proveedor
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {estado === E_EstadoFormPrograma.Agregar ? (
                      <Select
                        className={`${error("ID_PROVEEDOR")} borderColorGris`}
                        options={
                          comboPR.map((vcc) => ({
                            value: vcc.ID,
                            label: vcc.PROVEEDOR,
                          })) as any
                        }
                        placeholder="Seleccione"
                        value={refComboPR || ""}
                        isClearable={true}
                        onChange={async (e: any) => {
                          setValComboPR(e);
                          setProveedor(e.label);
                        }}
                      />
                    ) : (
                      <label>{planificacion?.PROVEEDOR}</label>
                    )}
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span className="text-danger"></span> Usuarios proveedor
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {estado === E_EstadoFormPrograma.Agregar ? returnValue() : planificacion?.PROVEEDOR_RESPONSABLE_DISPLAY ?? ""}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span className="text-danger">(*)</span> Fecha de evaluación
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    <Form.Control
                      onChange={(e) => {
                        setFechaDeteccion(e.target.value);
                      }}
                      defaultValue={fechaDeteccion}
                      type="date"
                      hidden={estado === E_EstadoFormPrograma.Lectura}
                      className={`${error("FECHA_EVALUACION")}`}
                    />
                    <label hidden={estado === E_EstadoFormPrograma.Agregar}>{shortDate(planificacion?.FECHA_EVALUACION)}</label>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span className="text-danger">(*)</span> Evaluador líder
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {estado === E_EstadoFormPrograma.Agregar ? (
                      <>
                        <UserPicker
                          name={"detectadoPor"}
                          callback={(id, value) => {
                            setValEvaluador(value?.shift() || null);
                          }}
                          id={"detectadoPor"}
                          key={"1"}
                          multi={false}
                          disabled={false}
                          className={`${error("EVALUADOR_LIDER")} borderColorGris`}
                          defaultValue={valEvaluador}
                        />
                        <label>
                          {valEvaluador?.mail === valEvaluadoresParticipantes?.mail && valEvaluador?.mail !== undefined
                            ? "El evaluador líder no puede ser el evaluador participante"
                            : ""}
                        </label>{" "}
                      </>
                    ) : (
                      <label>{planificacion?.EVALUADOR_LIDER_DISPLAY}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>Evaluadores participantes</label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {estado === E_EstadoFormPrograma.Agregar ? (
                      <>
                        <UserPicker
                          name={"detectadoPor"}
                          callback={(id, value) => {
                            setValEvaluadoresParticipantes(value?.shift() || null);
                          }}
                          id={"detectadoPor"}
                          key={"1"}
                          multi={false}
                          disabled={false}
                          className={`${error("EVALUADORES")} borderColorGris`}
                          defaultValue={valEvaluadoresParticipantes}
                        />

                        <label>
                          {proveedorSeleccionado?.PROVEEDOR_EXTERNO === valEvaluadoresParticipantes?.mail ||
                          proveedorSeleccionado?.USUARIOS === valEvaluadoresParticipantes?.mail
                            ? "El evaluador acompañante no puede ser el proveedor"
                            : ""}
                        </label>
                      </>
                    ) : (
                      <label>{planificacion?.EVALUADORES_DISPLAY}</label>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                    <button
                      hidden={planificacion?.PROVEEDOR_RESPONSABLE === currentUser?.email || !isAdmin}
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => (window.location.href = `/agregarprograma?id=${idProveedor}&new=1`)}
                      disabled={isSendingData}>
                      {" "}
                      Ingresar nuevo
                    </button>

                    <button
                      hidden={
                        (estado === E_EstadoFormPrograma.Lectura && id_planificacion > 0) || (plan?.RESPONSABLE !== currentUser?.email && !isAdmin)
                      }
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => handleGuardar(1)}
                      disabled={isSendingData}>
                      {" "}
                      Grabar
                    </button>
                    <button
                      hidden={
                        (estado === E_EstadoFormPrograma.Lectura && id_planificacion > 0) || (plan?.RESPONSABLE !== currentUser?.email && !isAdmin)
                      }
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => handleGuardar(1)}
                      disabled={
                        isSendingData ||
                        valEvaluador?.mail === valEvaluadoresParticipantes?.mail ||
                        proveedorSeleccionado?.PROVEEDOR_EXTERNO === valEvaluadoresParticipantes?.mail ||
                        proveedorSeleccionado?.USUARIOS === valEvaluadoresParticipantes?.mail
                      }>
                      {" "}
                      Continuar
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => (window.location.href = "/proveedores/home")}
                      disabled={isSendingData}>
                      Volver
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
